import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "@/views/Home.vue";// 主页

Vue.use(VueRouter)

const routes = [
 {
    path: '/',// 
    name: 'home',
    component: Home,
    meta: {
      title: '首页',
      isAuth: true,//是否需要登录
    },
  }

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

//全局前置路由守卫————初始化的时候被调用、每次路由切换之前被调用
// router.beforeEach((to, from, next) => {
//   //如果路由需要跳转
//   if (to.meta.isAuth) {

//     // console.log("需要登录")

//     //判断 如果school本地存储是qinghuadaxue的时候，可以进去
//     if (localStorage.getItem('token') === 'true') {
//       next()  //放行
//     } else {
//       next({
//         path: "/login"
//       })
//     }
//   } else {
//     // 否则，放行
//     next()
//   }
// })
export default router
